import { render, staticRenderFns } from "./ordonnance-lunettes.html?vue&type=template&id=72314a56&scoped=true&external"
import script from "./ordonnance-lunettes.js?vue&type=script&lang=js&external"
export * from "./ordonnance-lunettes.js?vue&type=script&lang=js&external"
import style0 from "./ordonnance-lunettes.scss?vue&type=style&index=0&id=72314a56&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72314a56",
  null
  
)

export default component.exports